import React from "react";
import { motion } from "framer-motion";

export default function StatCard({ label, value, index = 0, suffix }) {
  return (
    <motion.div
      className="pm-stat"
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.45, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <span className="pm-stat__eyebrow">{String(index + 1).padStart(2, "0")}</span>
      <div className="pm-stat__value">
        {value}
        {suffix && <span className="pm-stat__suffix">{suffix}</span>}
      </div>
      <div className="pm-stat__label">{label}</div>
    </motion.div>
  );
}
